<template>
    <div>
        <h1>Success Page</h1>
    </div>
</template>

<script>

</script>